define("settings/controllers/groups/group/social_profiles/new", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/constants"], function (_exports, _asyncArrowRuntime, _controller, _object, _computed, _service, _tracking, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let NewController = _exports.default = (_dec = (0, _service.inject)('social/connect-profiles'), _dec2 = (0, _computed.readOnly)('auth.currentUserModel.hasValidLinkedinUserToken'), (_class = class NewController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor3, this);
      _defineProperty(this, "queryParams", ['show_linkedin_selector']);
      _defineProperty(this, "path", 'account.groups.group.social_profiles');
      _initializerDefineProperty(this, "numberOfFreePlanSocialSets", _descriptor4, this);
      _initializerDefineProperty(this, "passedInSocialIdentityId", _descriptor5, this);
      _initializerDefineProperty(this, "selectedSocialProfile", _descriptor6, this);
      _initializerDefineProperty(this, "selectedSocialProfileType", _descriptor7, this);
      _initializerDefineProperty(this, "show_linkedin_selector", _descriptor8, this);
      _initializerDefineProperty(this, "hasValidLinkedinUserToken", _descriptor9, this);
      _defineProperty(this, "updateShowProfileProperty", (property, value) => {
        this.connectProfiles.updateProperty(property, value);
      });
      _defineProperty(this, "addLinkedinProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (id) {
          yield this.connectProfiles.addLinkedinProfile.perform({
            group: this.group,
            id,
            path: this.path
          });
        }
      }), null, "addLinkedinProfile", "drop"));
      _defineProperty(this, "addSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.connectProfiles.addSocialProfile.perform({
            selectedSocialProfileType: this.selectedSocialProfileType,
            group: this.group,
            area: 'settings',
            passedInSocialIdentityId: this.passedInSocialIdentityId
          });
        }
      }), null, "addSocialProfile", "restartable"));
    }
    get numberOfSocialSetsInGroup() {
      return this.group.socialIdentities.length;
    }
    get selectedSocialIdentity() {
      return this.connectProfiles.selectedSocialIdentity;
    }
    get showLinkedinSelector() {
      return this.show_linkedin_selector === 'true' ? true : false;
    }
    get showSocialSetSection() {
      return this.isAdmin || this.isMobileSubscription && this.hasRemainingSocialSets || !this.isMobileSubscription;
    }
    get isAdmin() {
      return this.auth.currentUserModel.admin;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get totalSocialSets() {
      return this.currentAccount.totalSocialSets;
    }
    get isPaid() {
      return this.subscriptions.isPaid;
    }
    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get canAddSocialSets() {
      return this.subscriptions.subscriptionPlan.canAddSocialSets;
    }
    get group() {
      return this.model;
    }
    get hasRemainingSocialSets() {
      return this.socialSetsRemaining > 0;
    }
    get numUsedSocialSets() {
      return this.auth.currentAccount.socialIdentitiesCount || 0;
    }
    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || this.numberOfFreePlanSocialSets) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }
    get submitDisabled() {
      return this.selectedSocialProfile === null && this.selectedSocialProfileType === null;
    }
    get showSnapchatLoginMessage() {
      return this.auth.currentAccount?.rolloutSnapchat && this.selectedSocialProfileType === _constants.SOCIAL_PROFILE_CODES.SNAPCHAT;
    }
    selectSocialProfile(socialProfile) {
      this.set('selectedSocialProfile', socialProfile);
    }
    toggleSelect(_ref) {
      let {
        socialIdentity,
        platform
      } = _ref;
      this.connectProfiles.updateProperty('selectedSocialIdentity', socialIdentity);
      this.set('selectedSocialProfileType', platform);
      this.set('passedInSocialIdentityId', socialIdentity.id);
    }
    async addFacebookProfile(uid, token, scopes) {
      await this.connectProfiles.addFacebookProfile({
        group: this.group,
        uid,
        token,
        scopes,
        path: 'cluster.schedule.calendar'
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "numberOfFreePlanSocialSets", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 1;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "passedInSocialIdentityId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return undefined;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfileType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "show_linkedin_selector", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasValidLinkedinUserToken", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addFacebookProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addFacebookProfile"), _class.prototype)), _class));
});